var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chick-fil-a-tag-info-button"}},[(_vm.isChickFilASchool)?_c('v-btn',_vm._b({staticClass:"white--text",class:{
      'chick-fil-a-dashboard-tag-button': _vm.service === 'dashboard',
      'chick-fil-a-playlist-tag-button': _vm.service === 'playlist-bulb-settings',
    },attrs:{"depressed":"","color":"#E51636"},on:{"click":function($event){$event.stopPropagation();return _vm.redirectToTagInformation()}}},'v-btn',_vm.vBtnProps,false),[_vm._v(" View tag library ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }